import React, { useState } from "react";
import { FaStar } from "react-icons/fa";
import { Helmet } from "react-helmet-async";

import "./McaCourse.css";
import {
  FaClock,
  FaLaptop,
  FaUserCheck,
  FaBookOpen,
  FaHandsHelping,
} from "react-icons/fa";

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Accordion,
  Form,
} from "react-bootstrap";
import { FaUniversity, FaGraduationCap, FaBook } from "react-icons/fa";
import { FaLayerGroup } from "react-icons/fa";
import { FaChartLine, FaHandshake, FaUsers } from "react-icons/fa";
import Slider from "react-slick";
import { FaPlus, FaMinus } from "react-icons/fa"; // ✅ using react-icons
import {
  FaSnowflake,
  FaUser,
  FaDollarSign,
  FaBuilding,
  FaTruck,
  FaPhoneAlt,
} from "react-icons/fa";
import Admission from "../../components/Admission";
import Partner from "../../components/Partner";
import {
  FaCode, // Software Developer
  FaGlobe, // Web Developer
  FaChartBar, // Data Analyst
  FaDesktop, // System Analyst
  FaDatabase, // Database Administrator
  FaCloud, // Cloud Engineer
  FaShieldAlt, // Cybersecurity Analyst
  FaProjectDiagram, // IT Project Manager
} from "react-icons/fa";

export default function BcaCourse() {
  const careers = [
    {
      icon: <FaCode size={40} color="#2196F3" />, // Blue
      title: "Software Developer",
    },
    {
      icon: <FaGlobe size={40} color="#4CAF50" />, // Green
      title: "Web Developer",
    },
    {
      icon: <FaChartBar size={40} color="#9C27B0" />, // Purple
      title: "Data Analyst",
    },
    {
      icon: <FaDesktop size={40} color="#FF9800" />, // Orange
      title: "System Analyst",
    },
    {
      icon: <FaDatabase size={40} color="#795548" />, // Brown
      title: "Database Administrator",
    },
    {
      icon: <FaCloud size={40} color="#03A9F4" />, // Sky Blue
      title: "Cloud Engineer",
    },
    {
      icon: <FaShieldAlt size={40} color="#F44336" />, // Red
      title: "Cybersecurity Analyst",
    },
    {
      icon: <FaProjectDiagram size={40} color="#607D8B" />, // Blue Grey
      title: "IT Project Manager",
    },
  ];

  const universities = [
    {
      name: "Subharti University",
      logo: "/images/subharti.png",
    },
    {
      name: "IGNOU",
      logo: "/images/ignou.png",
    },
    {
      name: "Andhra University",
      logo: "/images/andhra.png",
    },
    {
      name: "Amity University",
      logo: "/images/amity.png",
    },
    {
      name: "Lovely Professional University (LPU)",
      logo: "/images/lpu.png",
    },
    {
      name: "Sikkim Manipal University",
      logo: "/images/smu.png",
    },
    {
      name: "Chandigarh University",
      logo: "/images/chandigarh.png",
    },
    {
      name: "Jain University",
      logo: "/images/jain.png",
    },
    {
      name: "Annamalai University",
      logo: "/images/annamalai.png",
    },
    {
      name: "Delhi University (School of Open Learning)",
      logo: "/images/du.png",
    },
    {
      name: "Madras University",
      logo: "/images/madras.png",
    },
  ];

  const highlights = [
    {
      icon: "⏰",
      title: "Course Duration",
      description:
        "2 years (4 semesters) — designed for efficient learning while balancing work or other commitments.",
    },
    {
      icon: "📚",
      title: "Learning Mode",
      description:
        "Distance / Online — study from anywhere with access to online classes, study material, and recorded lectures.",
    },
    {
      icon: "🔍",
      title: "Eligibility",
      description:
        "A bachelor's degree (preferably BCA, B.Sc CS/IT) with Mathematics in 10+2 or graduation.",
    },
    {
      icon: "🏛️",
      title: "University Recognition",
      description:
        "Courses offered are from UGC and AICTE-approved universities, ensuring your degree is valid and recognized.",
    },
    {
      icon: "📖",
      title: "Curriculum",
      description:
        "Covers core programming, software engineering, DBMS, networking, cloud computing, and more.",
    },
    {
      icon: "🎧",
      title: "Support & Flexibility",
      description:
        "Study on your schedule with weekend sessions, recorded classes, student support, and online doubt-solving.",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const data = [
    { icon: <FaChartLine />, number: "100%", label: "Success Rate" },
    { icon: <FaHandshake />, number: "35+", label: "Years Of Service" },
    { icon: <FaUsers />, number: "8k+", label: "Students" },
    { icon: <FaBook />, number: "10+", label: "Courses" },
  ];

  const plans = [
    {
      id: "01",
      color: "#00c6ff",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "02",
      color: "#2ecc71",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "03",
      color: "#f1c40f",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "04",
      color: "#e67e22",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "05",
      color: "#9b59b6",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
    {
      id: "06",
      color: "#2980b9",
      text: "Lorem ipsum dolor sit amet consectetur adipiscing elit.",
    },
  ];

  const blogs = [
    {
      title: "Writing Class",
      image: "https://via.placeholder.com/400x250?text=Writing+Class",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Crafts Activities",
      image: "https://via.placeholder.com/400x250?text=Crafts+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
    {
      title: "Math Activities",
      image: "https://via.placeholder.com/400x250?text=Math+Activities",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget rutrum massa, id pharetra nunc.",
    },
  ];

  const faqData = [
    {
      question: "What is a Distance BCA program?",
      answer:
        "A Distance BCA is a three-year undergraduate degree in computer applications offered online or through correspondence, covering programming, software development, and IT fundamentals without the need for regular campus attendance.",
    },
    {
      question: "Is a Distance BCA recognized and valid for jobs?",
      answer:
        "Yes. A Distance BCA from a UGC or AICTE-approved university is fully valid for private and government jobs as well as for higher education like MCA or MBA in IT.",
    },
    {
      question: "What are the eligibility criteria for BCA distance education?",
      answer:
        "Applicants typically need to have completed 10+2 or an equivalent qualification from a recognized board, preferably with Mathematics or Computer Science as a subject.",
    },
    {
      question: "How long does it take to complete a Distance BCA?",
      answer:
        "Most Distance BCA programs are designed to be completed in 3 years, divided into 6 semesters, with some universities offering flexible schedules or extended durations if required.",
    },
    {
      question: "Can I work while pursuing a Distance BCA?",
      answer:
        "Yes. Distance BCA programs are ideal for working professionals and students who need flexibility, allowing you to access study materials and online classes on your own schedule.",
    },
    {
      question: "What career opportunities are available after a Distance BCA?",
      answer:
        "Graduates can pursue careers as Software Developers, Web Developers, System Analysts, Database Administrators, or continue with higher studies like MCA or MBA in Information Technology.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const steps = [
    {
      num: "1",
      title: "Fill the Application Form",
      text: "Establishing goals & blueprints for the new website",
      icon: "🔍",
    },
    {
      num: "2",
      title: "Document Verification",
      text: "Defining information architecture & content plan",
      icon: "📝",
    },
    {
      num: "3",
      title: "Confirm Admission & Pay Fees",
      text: "Designing the form & function of the website",
      icon: "🎨",
    },
  ];

  const features = [
    {
      icon: <FaSnowflake />,
      title: "Study While You Work",
      details:
        "You don’t have to leave your job to pursue higher education. The flexible format allows you to manage both work and studies efficiently.",
    },
    {
      icon: <FaUser />,
      title: "Access Anytime, Anywhere",
      details:
        "Study from any location at your convenience. All course materials, video lectures, and assignments are accessible online—no need to attend physical classes.",
    },
    {
      icon: <FaDollarSign />,
      title: "Lower Cost, Same Degree",
      details:
        "Distance education is typically more affordable than traditional on-campus programs. Yet, the degree you earn is the same and equally valid.",
    },
    {
      icon: <FaBuilding />,
      title: "UGC/AICTE Approved Programs",
      details:
        "Your MCA degree comes from recognized institutions, ensuring credibility for jobs, promotions, or further studies.",
    },
    {
      icon: <FaTruck />,
      title: "Career-Aligned Curriculum",
      details:
        "The course content is tailored to match industry requirements with subjects like programming, software development, cloud computing, and AI.",
    },
    {
      icon: <FaPhoneAlt />,
      title: "Self-Paced Learning with Expert Support",
      details:
        "You can learn at your own speed and still receive academic guidance, doubt-solving sessions, and mentorship when needed.",
    },
  ];

  const highlightsData = [
    {
      icon: <FaClock size={36} className="text-primary mb-3" />,
      title: "Course Duration",
      description:
        " The BCA program spans three years, divided into six structured semesters, providing learners with a steady progression of theoretical concepts and practical computer science skills.",
    },
    {
      icon: <FaLaptop size={36} className="text-success mb-3" />,
      title: "Learning Mode",
      description:
        "Delivered through flexible online or correspondence formats, this program ensures working professionals and remote learners can balance studies conveniently without compromising on educational quality.",
    },
    {
      icon: <FaUserCheck size={36} className="text-warning mb-3" />,
      title: "Eligibility",
      description:
        " Applicants must have passed 10+2 or equivalent examinations from a recognized board, with mathematics or computer science background preferred for better understanding of core subjects.",
    },
    {
      icon: <FaUniversity size={36} className="text-info mb-3" />,
      title: "University Recognition",
      description:
        " Programs are offered by reputed universities across India, fully accredited and UGC-DEB approved, ensuring degrees carry national recognition and industry-wide career relevance.",
    },
    {
      icon: <FaBookOpen size={36} className="text-danger mb-3" />,
      title: "Curriculum",
      description:
        " The curriculum covers programming, data structures, database management, networking, and web development, combining foundational theory with practical applications for diverse IT roles.",
    },
    {
      icon: <FaHandsHelping size={36} className="text-secondary mb-3" />,
      title: "Support & Flexibility",
      description:
        " Students gain self-paced learning benefits, access to digital study materials, recorded lectures, and expert academic guidance, creating an engaging and flexible educational environment.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>
          Best Online BCA Colleges | BCA Distance Education Bangalore
        </title>
        <meta
          name="description"
          content="Join BCA distance education in Bangalore at UGC-approved BCA online colleges. Flexible online BCA courses and correspondence programs for career growth."
        />
      </Helmet>

      <div className="mca-course-page">
        {/* ===== MCA Course Header ===== */}
        <section className="mca-course-header py-5 text-white">
          <Container>
            <Row className="align-items-center">
              {/* MCA Course Info */}
              <Col md={7} className="mca-course-header-content">
                <span className="mca-course-badge badge bg-warning text-dark mb-3">
                  Live Classes
                </span>
                <h1 className="mca-course-title fw-bold mb-3">
                  Bachelor of Computer Applications (BCA){" "}
                </h1>
                <p className="mca-course-subtitle lead mb-3">
                  This MCA program is designed to build a strong foundation in
                  computer applications, programming, software development, and
                  IT management. You’ll gain advanced skills required for
                  careers in the tech industry.
                </p>
                <Button
                  variant="warning"
                  size="lg"
                  className="mca-course-enroll-btn fw-bold"
                >
                  Get admitted to the batch
                </Button>

                {/* MCA Course Rating */}
                <div className="mca-course-rating mt-3 d-flex align-items-center">
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <FaStar className="text-warning me-1" />
                  <span className="ms-2">(4.8)</span>
                </div>
              </Col>

              {/* MCA Course Thumbnail */}
              <Col md={5} className="mca-course-header-thumbnail text-center">
                <img
                  src="/images/361965-removebg-preview.png"
                  alt="MCA Course Preview"
                  style={{ height: "600px" }}
                />
              </Col>
            </Row>
          </Container>
        </section>

        {/* ===== MCA Course Content Section ===== */}

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              BCA Distance Education – Begin Your Journey in the World of IT{" "}
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              The Bachelor of Computer Applications (BCA) distance education
              program is perfect for students aspiring to build a career in the
              IT and software industry. This 3-year undergraduate course
              provides a strong foundation in computer science, programming,
              database management, web development, and networking. Offered by
              UGC-approved BCA distance education universities, the program is
              designed for both students and working professionals who want
              flexibility without compromising on quality. With access to online
              BCA courses in Bangalore, you can learn at your own pace while
              gaining practical skills needed for roles in IT support, software
              development, and system administration. Recognized as one of the
              best BCA distance learning colleges in Bangalore, this program
              combines theoretical knowledge with hands-on learning. Whether you
              want to advance as a software developer, pursue higher education
              like MCA, or explore diverse opportunities in the tech industry,
              enrolling in a BCA correspondence course in Bangalore is a smart
              step toward a successful IT career.
            </p>
          </Container>
        </section>

        <section
          style={{ background: "linear-gradient(to right, #f9fafb, #eef2ff)" }}
          className="py-5"
        >
          <Container>
            {/* Heading */}
            <div className="text-center mb-5">
              <h2 className="fw-bold text-dark display-6">
                Key Highlights of the BCA Program
              </h2>
              <p className="text-muted fs-5 mt-3 px-md-5">
                Making quality education accessible, flexible, and
                career-focused for learners across India
              </p>
            </div>

            {/* Highlights Grid */}
            <Row className="g-4">
              {highlightsData.map((highlight, index) => (
                <Col md={6} key={index}>
                  <Card className="h-100 shadow border-0 text-center">
                    <Card.Body>
                      {highlight.icon}
                      <h5 className="fw-bold">{highlight.title}</h5>
                      <p className="text-muted">{highlight.description}</p>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h2
              className="text-center fw-bold mb-4"
              style={{ fontSize: "2rem", color: "#333" }}
            >
              BBA Distance Education – Advance Your Career in Business &
              Management
            </h2>

            {/* Paragraphs */}
            <p
              className="mx-auto"
              style={{
                maxWidth: "1100px",
                fontSize: "1.1rem",
                lineHeight: "1.8",
                color: "#6c757d",
              }}
            >
              The Bachelor of Business Administration (BBA) distance education
              program is a 3-year undergraduate degree designed for individuals
              who want to build or advance their careers in business,
              management, and entrepreneurship. Through UGC-approved BBA
              distance education in Bangalore, students can earn a recognized
              degree without attending regular on-campus classes. This flexible
              learning mode is ideal for working professionals, recent
              graduates, and those seeking foundational business knowledge while
              managing other commitments. The distance BBA program in Bangalore
              covers key subjects like Business Management, Marketing, Financial
              Accounting, Human Resource Management, Economics, and Business
              Communication. The curriculum aligns with industry requirements
              and develops analytical thinking, leadership, and decision-making
              skills for roles such as business executive, marketing associate,
              HR officer, or operations manager. Flexibility is a major
              advantage of pursuing a BBA correspondence course in Bangalore.
              Students can study at their convenience, access online learning
              materials, attend virtual lectures, and appear for assessments
              remotely. The program is more affordable than regular on-campus
              courses while offering the same degree value and recognition.
              Enrolling in a distance BBA course from reputed universities
              ensures your degree is valid for government jobs, private sector
              employment, or higher education like MBA programs. Whether aiming
              to climb the corporate ladder, start a business, or pursue further
              studies, a BBA distance education program equips you with
              essential business knowledge and practical skills for success.
            </p>
          </Container>
        </section>

        <section className="why-section">
          <div className="why-head">
            <h1>Why Choose BCA via Distance Education?</h1>
          </div>
          <div className="why-container">
            {/* Left image */}
            <div className="why-image">
              <img
                src="/images/whychoose.jpg"
                alt="Why Choose Bangalore Distance Education for Your BCA Distance Education"
              />
            </div>

            {/* Right content */}
            <div className="why-content">
              <p className="section-text">
                Distance BCA programs are becoming increasingly popular for
                students and working professionals who want to advance their
                careers without disrupting their current schedules. Here’s why
                choosing an BCA through distance education is a smart move:
              </p>

              <div className="features-grid">
                {features.map((item, idx) => (
                  <div key={idx} className="feature-card">
                    <div className="feature-icon">{item.icon}</div>
                    <div>
                      <h3 className="feature-title">{item.title}</h3>
                      <p className="feature-text">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Admission Process */}

        <Admission></Admission>

        <section className="py-5" style={{ backgroundColor: "#fff" }}>
          <Container>
            {/* Heading */}
            <h1 className="text-center mb-5">Career Opportunities After BCA</h1>
            <p
              className="text-center mb-5"
              style={{ color: "#666", fontSize: "16px" }}
            >
              Earning an BCA through distance education opens up diverse career
              opportunities in the growing tech industry. With advanced
              knowledge in programming, software systems, and IT management, BCA
              graduates are highly sought after in both private and public
              sectors.
            </p>

            {/* Career Grid */}
            <Row className="text-center">
              {careers.map((career, index) => (
                <Col key={index} xs={12} sm={6} md={3} className="mb-4">
                  <div style={{ fontSize: "48px" }}>{career.icon}</div>
                  <h6 className="fw-bold mt-3">{career.title}</h6>
                </Col>
              ))}
            </Row>
          </Container>
        </section>

        <Partner></Partner>

        <Container className="my-5">
          <Row className="justify-content-center">
            <Col md={10} lg={8}>
              <h1 className="fw-bold display-6 mb-3">
                Take the Next Step with Our Distance PhD Program
              </h1>
              <p className="text-muted fs-5">
                Ready to elevate your academic journey and advance your career?
                Our Distance PhD program, including PhD distance education and
                PhD distance education in Bangalore, is designed for ambitious
                professionals and researchers who want to pursue doctoral
                studies without interrupting their current commitments. With
                flexible learning options through online PhD courses in
                Bangalore, PhD correspondence courses in Bangalore, and
                UGC-approved PhD distance education, you gain expert
                supervision, structured mentorship, and recognized accreditation
                from top universities. Whether your goal is a career in
                academia, high-level research, or industry leadership, our
                program equips you with the skills, knowledge, and credentials
                needed to succeed. Explore opportunities at best online PhD
                colleges, distance PhD colleges in Bangalore, and UGC-approved
                PhD online programs to ensure your doctorate journey is smooth
                and credible. Take the next step today and start your PhD
                journey with confidence at the best PhD distance learning
                colleges in Bangalore.
              </p>
            </Col>
          </Row>
        </Container>

        {/* Register Now */}

        <div className="event-wrapper">
          {/* Curved shape */}
          <div className="curve"></div>

          {/* Left section */}
          <div className="left-section">
            <br />
            <h2>WE APPRECIATE ALL YOU DO</h2>
            <h3>Take the Next Step with Our Distance BCA Program</h3>
            <p>
              Looking to upgrade your career in the IT field? Our UGC-approved
              BCA program is designed for future-ready professionals who want to
              build strong expertise in software development, programming, and
              system architecture — all from the comfort of home. Whether you’re
              a BCA graduate, a working professional, or someone passionate
              about tech, this course offers the flexibility, affordability, and
              industry-aligned curriculum you need to grow. Fill out the form to
              get expert guidance on admissions, course details, and university
              options — and begin your BCA journey with confidence.
            </p>
          </div>

          {/* Right section */}
          <div className="right-section">
            <form className="form-card">
              <h2>Registration</h2>
              <hr className="divider" />

              <input type="text" placeholder="Full Name*" />
              <input type="email" placeholder="Email*" />
              <input type="number" name="" id="" placeholder="Phone" />

              <button type="submit" className="register-btn">
                Register
              </button>

              <p className="footer-note">Your perfect events registrations</p>
            </form>
          </div>
        </div>

        {/* FAQ */}
        <section className="faq-section py-5">
          <Container>
            <Row>
              <h1 className="text-center mb-5">
                Frequently Asked Questions (FAQ)
              </h1>
            </Row>

            <Row>
              {faqData.map((faq, index) => (
                <Col md={6} key={index} className="mb-4">
                  <div
                    className={`faq-card ${
                      openIndex === index ? "active" : ""
                    }`}
                    onClick={() => toggleFAQ(index)}
                  >
                    <div className="faq-question">
                      <span>{faq.question}</span>
                      <span className="faq-icon">
                        {openIndex === index ? <FaMinus /> : <FaPlus />}
                      </span>
                    </div>
                    {openIndex === index && (
                      <div className="faq-answer">{faq.answer}</div>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}
